// The MIT License
//
// Copyright (c) 2019 Google, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

const CSS_CLASSES = {
  ROOT: 'mdc-layout-grid',
  INNER: 'mdc-layout-grid__inner',
  CELL: 'mdc-layout-grid__cell',
  CELL_SPAN: 'mdc-layout-grid__cell--span',
  CELL_ORDER: 'mdc-layout-grid__cell--order',
  CELL_ALIGN: 'mdc-layout-grid__cell--align',
  FIXED_COLUMN_WIDTH: 'mdc-layout-grid--fixed-column-width',
  ALIGN: 'mdc-layout-grid--align',
};

const DEVICE_TYPE = {
  DESKTOP: 'desktop',
  PHONE: 'phone',
  TABLET: 'tablet',
};

export {CSS_CLASSES, DEVICE_TYPE};
